export enum VariantRepresenations {
  ShowVariant = "eine zufällige Variante anzeigen",
  ShowVariantsAsList = "alle Varianten anzeigen",
  ShowMaster = "Master anzeigen"
}
